module.exports = __webpack_public_path__ + "img/Karabell.c6362cf0.jpg";